import { PageFilter } from '../state/app';
import { SalesGroup, SalesGroupListFilter } from '../state/salesGroup';
import axios from '../utils/axios';

const baseUrl = `/api/salesGroups`;

export const fetchSalesGroupList = async ({
  filters,
  paging,
}: {
  filters: SalesGroupListFilter;
  paging: PageFilter;
}) => {
  const params = new URLSearchParams();
  params.append('cacheBuster', new Date().getTime().toString());
  params.append('pageSize', paging.pageSize.toString());
  params.append('pageNumber', paging.pageNumber.toString());

  Object.entries(filters).forEach(([key, value]) => {
    params.append(key, value);
  });

  const requestUrl = `${baseUrl}`;
  return await axios.get(`${requestUrl}?${params.toString()}`);
};

export const fetchSalesGroup = async (id: SalesGroup['id']) => {
  const requestUrl = `${baseUrl}/${id}`;
  return await axios.get(requestUrl);
};

export const createSalesGroup = async (salesGroup: SalesGroup) => {
  const requestUrl = `${baseUrl}`;
  return await axios.post(requestUrl, salesGroup);
};

export const updateSalesGroup = async (salesGroup: SalesGroup) => {
  const requestUrl = `${baseUrl}`;
  return await axios.put(requestUrl, salesGroup);
};
